
import { InitOptions } from './player';

const defaultOptions = {
    "source": {
        "url": ""
    },
    "posterFit": "contain",
    "autoplay": "viewable",
    "audio": true,
    "fit": "contain",
    "ratio": -1,
    "bgColor": "#000000",
    "controls": {
        "settings": {
            "textButton": "hover",
            "volume": {
                "range": true,
                "orientation": "landscape"
            },
            "playbackRates": [
                0.5,
                1,
                1.5,
                2
            ],
            "seekControlInterval": 10,
            "hideAfterInactivityTimeout": 5000
        },
        "progressBar": {
            "show": true,
            "position": "center-bottom-controls",
            "hoverShow": true,
            "hover": "time"
        },
        "bigButton": {
            "show": true,
            "firstTimeOnly": true,
            "showControlBigButtonDisplayed": true,
            "showMute": true,
            "shrinkMuteAfterTimeout": -1,
            "stickyMute": true
        },
        "liveAutoHide": [
            "play",
            "seek_control_rewind",
            "seek_control_forward",
            "time_info",
            "playbackRates_selector",
            "progress_bar"
        ],
        "topLeft": [
            "title"
        ],
        "bottomLeft": [
            "play",
            "volume",
            "seek_control_rewind",
            "seek_control_forward",
            "time_info",
            "live_dvr_indicator"
        ],
        "bottomRight": [
            "qualityLevels_selector",
            "audiotracks_selector",
            "videotracks_selector",
            "texttracks_selector",
            "playbackRates_selector",
            "sub_menu",
            "pip",
            "fullscreen"
        ],
        "specificDevices": [
            {
                "device": {},
                "size": "xs",
                "controls": {
                    "hideList": [
                        "seek_control_rewind",
                        "seek_control_forward",
                        "time_info"
                    ],
                    "bottomRight": [
                        "sub_menu",
                        "pip",
                        "fullscreen"
                    ],
                    "subMenu": [
                        "qualityLevels_selector",
                        "audiotracks_selector",
                        "videotracks_selector",
                        "texttracks_selector",
                        "playbackRates_selector"
                    ]
                }
            },
            {
                "device": {},
                "size": "xxs",
                "controls": {
                    "hideList": [
                        "seek_control_rewind",
                        "seek_control_forward",
                        "time_info"
                    ],
                    "bottomLeft": [
                        "play"
                    ],
                    "bottomRight": [
                        "sub_menu",
                        "fullscreen"
                    ],
                    "subMenu": [
                        "qualityLevels_selector",
                        "audiotracks_selector",
                        "videotracks_selector",
                        "texttracks_selector",
                        "playbackRates_selector"
                    ],
                    "progressBar": {
                        "position": "bottom"
                    }
                }
            },
            {
                "device": {
                    "osName": "iOS"
                },
                "controls": {
                    "settings": {
                        "click": "controls"
                    }
                }
            },
            {
                "device": {
                    "deviceType": "tablet"
                },
                "controls": {
                    "settings": {
                        "volume": {
                            "range": false
                        }
                    }
                }
            },
            {
                "device": {
                    "deviceType": "mobile"
                },
                "controls": {
                    "settings": {
                        "volume": {
                            "range": false
                        }
                    }
                }
            }
        ]
    },
    "initialValues": {
        "autoSelectWithViewerLanguage": true
    },
    "locale": {
        "automatic_detection": true
    },
    "logo": {
        "position": "top-left",
        "maxWidth": 20
    },
    "providersOptions": {
        "hls": {
            "preventLoopBack": true,
            "reloadOnFatalError": 3000
        }
    },
    "responsive": [
        {
            "width": 320,
            "className": "xxs"
        },
        {
            "width": 540,
            "className": "xs"
        },
        {
            "width": 768,
            "className": "sm"
        },
        {
            "width": 960,
            "className": "md"
        }
    ],
    "shortcuts": [
        {
            "action": "play",
            "key": "p",
            "altKey": true
        },
        {
            "action": "fullscreen",
            "key": "f",
            "altKey": true
        },
        {
            "action": "mute",
            "key": "m",
            "altKey": true
        }
    ],
    "liveSettings": {
        "retryIfNoLive": true,
        "retryTimeout": 3000
    },
    "dvrSettings": {
        "showControl": true,
        "delayStillConsideringLive": 5
    }
}; 

export default defaultOptions as InitOptions;